import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from './authStore';

export function NavigationHandler() {
  const navigate = useNavigate();
  const setNavigate = useAuthStore((s) => s.setNavigate);

  useEffect(() => {
    setNavigate((path: string) => {
      void navigate(path);
    });
  }, [navigate, setNavigate]);

  return null;
}
